export enum HttpResponseErrorCode {
  LOCK_VERIFICATION_FAILED = 'lock_verification_failed'
}
